import {CityProps, translatedCityProps} from 'modules/cities/types';
import {CompanyProps, translatedCompanyProps} from 'modules/companies/types';
import {CouponProps, translatedCouponProps} from 'modules/coupons/types';
import {OrderProps, translatedOrderProps} from 'modules/orders/types';
import {translatedUserProps, UserProps} from 'modules/users/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface CouponRedemptionProps {
  id: string;
  companyId: string;
  company: CompanyProps;
  city: CityProps;
  cityId: string;
  user: UserProps;
  userId: string;
  coupon: CouponProps;
  couponId: string;
  order: OrderProps;
  orderId: string;
  redeemedAt: Date;
  phone: string;
}

export const translatedCouponRedemptionProps: TranslatedKeys<CouponRedemptionProps> =
  {
    companyId: 'Empresa',
    company: {...translatedCompanyProps, name: 'Empresa'},
    city: {...translatedCityProps, name: 'Cidade'},
    cityId: 'Cidade',
    user: {...translatedUserProps, name: 'Usuário'},
    userId: 'Usuário',
    coupon: {...translatedCouponProps, name: 'Cupom'},
    couponId: 'Usuário',
    order: {...translatedOrderProps, number: 'Pedido'},
    orderId: 'Usuário',
    redeemedAt: 'Data',
    phone: 'Telefone',
  };
